<img [ngClass]="imageClass" #logoImage>


